
<div class="overview">
  <section class="card">
    <h3 class="card__title">
        <span class="card__info" aria-hidden="true">i</span>
        <span>{{ 'FEATURES.OVERVIEW_PAGE.SPECIFICATIONS' | transloco }}</span>
    </h3>
    <div class="grid">
    @for (r of rows; track r.label) {
    <div class="item">
        <span class="item__label">{{ r.label }}</span>
        <span class="item__sep">:</span>
        @if (r.loading) {
        <span class="item__skeleton"></span>
        } @else {
        <span class="item__value">{{ r.value }}</span>
        @if (r.badge) { <span class="item__badge">{{ r.badge }}</span> }
        }
    </div>
    }
    </div>
  </section>

  <section class="support">
    <h3 class="support__title"><mat-icon class="support__icon" svgIcon="headset_mic"></mat-icon>
        <span>{{ 'FEATURES.OVERVIEW_PAGE.Title' | transloco }}</span></h3>
    <p class="support__text">{{ 'FEATURES.OVERVIEW_PAGE.SUPPORT' | transloco }}</p>
    <div class="support__btn" role="button" tabindex="0" (click)="openTicket()" (keydown.enter)="openTicket()">
      <mat-icon svgIcon="open_in_new"></mat-icon>
       <span>{{'FEATURES.OVERVIEW_PAGE.TICKET' | transloco }}</span>
    </div>
  </section>
</div>